import { default as team } from "../assets/images/why_us/team.svg";
import { default as tax } from "../assets/images/why_us/tax.svg";
import { default as support } from "../assets/images/why_us/support.svg";
import { default as network } from "../assets/images/why_us/network.svg";
import { default as online } from "../assets/images/why_us/online.svg";
import { default as lic } from "../assets/images/aboutus/license.svg";
import { default as taxsave } from "../assets/images/aboutus/tax_consultancy.svg";
import { default as business } from "../assets/images/aboutus/businessgrow.svg";
import { default as fin } from "../assets/images/aboutus/mission.svg";
export const hero_swiper_content: any[] = [
  {
    svg: tax,
    label: "Tax Return Filing",
    content: `The easiest, secure and most reliable way to get your Tax
      return filed with our affordable plans`,
  },
  {
    svg: lic,
    label: "Licenses & Trademarks",
    content: `Hassle free drafting &amp; filing of Trademark
      application, all taken care of by our TM specialist.`,
  },
  {
    svg: taxsave,
    label: "Tax Consultancy",
    content: `Our Tax Experts help you with will tax related problems
      to optimize your Tax liability`,
  },
  {
    svg: fin,
    label: "Financial Consultancy",
    content: `Investment and wealth management advice customized to
      cater various risk profiles`,
  },
  {
    svg: business,
    label: "Business Registrations",
    content: `You one stop shop to apply all your business and tax
      registrations at one place`,
  },
];

export const pricingCards = [
  {
    cat: "personal",
    label: `Income Tax
    Return Filing`,
    price: `599`,
    sublabel: `Get your return filed with help of our Tax experts at your convenience.`,
  },
  {
    cat: "personal",
    label: `Tax Consultancy & Notice Management`,
    price: `599`,
    sublabel: `Subscribe to our tax consultancy services and some tax.
    Received an income tax notice? Don’t worry. We got you covered!`,
  },
  {
    cat: "personal",
    label: `Financial Consultancy`,
    price: `999`,
    sublabel: `Consult our financial advisor to manage your wealth and achieve financial goals.`,
  },
  {
    cat: "business",
    label: `Income Tax
    Return Filing`,
    price: `1,999`,
    sublabel: `Get the Income Tax return of your business filed with the help of our Tax experts at your convenience.`,
  },
  {
    cat: "business",
    label: `Business Registrations`,
    price: `999`,
    sublabel: `Starting a business? Confused about license requirements? Don’t worry.. we are here to help. Get all your legal, compliances & registrations requirement fulfilled without any hassles`,
  },
  {
    cat: "business",
    label: `GST & TDS
    Return`,
    price: `999`,
    sublabel: `File GST & TDS return of your business without any hassles, with the help of our Tax experts.`,
  },
];

export const whyUsContent = [
  {
    img: tax,
    label: `100% Accurate
    Tax Compliance`,
    content: `Don’t worry about non-compliance. Our team of experts are here to
    ﬁle your returns with utmost accuracy. Leave all your worries to
    us and focus on your business.`,
  },
  {
    img: network,
    label: `Easy Reachability`,
    content: `You can reach out to us via various channels - text, calls,
    emails, Whatsapp. We recommend using Whatsapp for a super quick
    response and email for sharing documents.`,
  },
  {
    img: support,
    label: `Excellent Support 
   Documentation`,
    content: `Reach out to us for any query after the services. We will be
    happy to help you! Get all your documents in your dashboard
    arranged at one place for your easy reference.`,
  },
  {
    img: team,
    label: `Dedicated 
    Expert Teams`,
    content: `Dedicated tax or financial expert is assigned to serve you
    effectively, smoothly and on time`,
  },
  {
    img: online,
    label: `Complete Online &  
    Hassle free process`,
    content: `Don’t worry about non-compliance. Our team of experts are here to
    ﬁle your returns with utmost accuracy. Leave all your worries to
    us and focus on your business.`,
  },
];

export const serviceContent = [
  {
    key: "0",
    label: `Solution to all your tax and financial needs Services We Offer:`,
    content: `We offer a wide range of services to cover all your compliance & financial needs. Our team of tax and subject matter experts are here to help you manage your tax and other business compliances. Right from business and tax registrations to periodic compliance return filings, accounting, finance management and more, all types of services are offered by us.
    If you don't find required services listed in the pricing, reach out to us for quote for custom service and we will be happy to help you.`,
    points: `<p><strong  >Some of the key services we offer are:</strong></p>
    <ul>
        <li>Business Registration &amp; Company Incorporation</li>
        <li>Tax Registrations &amp; Licences</li>
        <li>Taxation consultancy</li>
        <li>Income Tax Return filing</li>
        <li>Corporate compliance filings</li>
        <li>GST &amp; TDS Return filing</li>
        <li>Trademark registration</li>
        <li>Financial consultancy</li>
    </ul>`,
  },
  {
    key: "1",
    label: `Tax Return Filing`,
    content: `In general, there are two types of taxes in India – direct tax and indirect tax. Direct tax is a tax that is calculated and paid directly on your Income e.g. tax on salary etc. Income tax is a direct tax. Indirect tax is a tax that is indirectly charged to you on purchase of goods or use of service e.g. Buying a mobile phone or eating in a fast food joint. The seller of the mobile phone or the fast food service provider charges you tax and then deposits the same to the Government account. Most indirect taxes are now covered under Goods and Services Tax (GST), a comprehensive, multistage, destination-based tax. Everyone who earns income above a certain amount is subject to income tax. Your income could be from salary, interest income from savings, income from mutual funds, sale of property or business or professional income. Income tax rates are pre-decided at the start of the year in the Union Budget (in the Parliament of India). The tax paid or deducted on these incomes is called the income tax. Filing income tax is every citizen’s responsibility. The IT department verifies these declarations of income and if any amount has been paid in excess, the department refunds the amount to the assessee’s bank account. All entities are required to file the taxes on time to avoid penalty. The form that contains information of income and tax paid of an assessee is called Income Tax Return. The Income Tax Department of India has various forms for it such as ITR 1, ITR 2, ITR 3, ITR 4S, ITR 5, ITR 6 and ITR 7.`,
    points: `<p>What do we offer in Tax Return Filing?</p>
    <ul>
        <li>Income Tax Return filing for individual</li>
        <li>Income Tax Return filing for business</li>
        <li>GST Return Filing</li>
        <li>TDS Return Filing</li>
        <li>Notice Management</li>
        <li>Handling Tax Assessment</li>
    </ul>`,
  },
  {
    key: "2",
    label: `License & Trademarks`,
    content: ` `,
    points: `<p><strong>What do we oﬀer in Tax Return Filing?</strong></p>
    <ul>
        <li>Trademark, Patent &amp; copyrights</li>
        <li>FSSAI License</li>
        <li>Digital Signature</li>
    </ul>`,
  },
  {
    key: "3",
    label: `Financial Consultancy`,
    content: ` `,
    points: `<p><strong>What do we oﬀer in Tax Return Filing?</strong></p>
    <ul>
        <li>Financial Advisory for Mutual Funds</li>
        <li>Portfolio management services</li>
        <li>Customized Services</li>
    </ul>`,
  },
];

export const pricingCardContent = [
  {
    key: "0",
    type: "individual",
    label: `Salary Income`,
    price: `599`,
    plans: ` <li>Income Tax Return filing for Salary Income</li>
    <li>Includes income from House Property</li>
    <li>Includes Dividend and Interest Income</li>
    <li>Tax saving investment options</li>
    <li>Tax deductions &amp; refunds</li>`,
  },
  {
    key: "1",
    type: "individual",
    label: `Capital Gains`,
    price: `1599`,
    plans: ` <li>Capital gains from sale of property</li>
    <li>Capital gains from sale of stocks &amp; mutual funds</li>
    <li>Capital gains from lottery &amp; other winning</li>
    <li>Tax saving advice on capital gains</li>`,
  },
  {
    key: "2",
    type: "individual",
    label: `Non Residents`,
    price: `2999`,
    plans: ` <li>Includes everything from Capital Gains plan</li>
    <li>Income earned outside India</li>
    <li>Income earned in India by Non resident</li>
    <li>Tax relief / credit under DTAA</li>`,
  },
  {
    key: "3",
    type: "business",
    label: `Company Incorporation`,
    price: `7499`,
    plans: `  <li>Incorporation of Private limited company</li>
    <li>Filing of SPICe form</li>
    <li>Name Approval in RUN</li>
    <li>Digital Signature for 2 directors</li>
    <li>Government fees and stamp duty included for Authorized capital upto Rs 1 lakh</li>`,
  },
  {
    key: "4",
    type: "business",
    label: `GST Registration and filing - Annual`,
    price: `11999`,
    plans: `<li>GST Registration for a new business</li>
    <li>Filing of monthly return - GSTR 1 and GSTR 3B for complete financial year</li>
    <li>Reconciliation of Input Tax credit with GSTR 2B</li>
    <li>Filing of Annual return - GSTR 9</li>`,
  },
  {
    key: "5",
    type: "business",
    label: `GST Registration and Filing - Quarter`,
    price: `2999`,
    plans: `    <li>Filing of monthly return - GSTR 1 and GSTR 3B for 3 months</li>
    <li>Reconciliation of Input Tax credit with GSTR 2B</li>
    <li>Review of ITC credit to optimize tax liability</li>
    <li>Both Sales &amp; Purchase return covered</li>`,
  },
];
